import React from 'react';

export default function PasswordArsenal({ globalPasswords, newPassword, onNewPasswordChange, onAddPassword, onRemovePassword, onUpdatePasswords }) {
  return (
    <div className="bg-gray-900 border border-cyan-500/30 rounded-xl p-4 lg:p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-cyan-400 font-bold text-base lg:text-lg">PASSWORD ARSENAL</h3>
        <button onClick={onUpdatePasswords} className="bg-green-600 hover:bg-green-700 px-4 py-1.5 rounded-lg text-sm font-bold">SAVE</button>
      </div>
      <div className="flex flex-col sm:flex-row gap-2 mb-3">
        <input
          type="text" value={newPassword} onChange={(e) => onNewPasswordChange(e.target.value)}
          placeholder="Add new password..."
          className="flex-1 px-4 py-2 bg-black border border-gray-700 rounded-lg text-white focus:border-cyan-500 outline-none"
          onKeyPress={(e) => e.key === 'Enter' && onAddPassword()}
        />
        <button onClick={onAddPassword} className="bg-cyan-600 hover:bg-cyan-700 px-6 py-2 rounded-lg font-bold whitespace-nowrap">ADD</button>
      </div>
      <div className="flex flex-wrap gap-2">
        {globalPasswords.map((pass, idx) => (
          <div key={idx} className="bg-cyan-600/20 border border-cyan-500/50 px-3 py-2 rounded-lg flex items-center gap-2">
            <span className="text-white font-mono font-bold">{pass}</span>
            <button onClick={() => onRemovePassword(idx)} className="text-red-400 hover:text-red-300 font-bold">×</button>
          </div>
        ))}
      </div>
    </div>
  );
}
